import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SessionNotes } from '../SessionDetail/SessionNotes/SessionNotes';

export const useSessionDetailsCard = (combinedSessionObject) => {
  const { t } = useTranslation();
  const { userIsAdmin: isAdmin } = useSelector((state) => state.authentication);

  const hasPractitionerCommands = combinedSessionObject.practitioner_commands;
  const hasClientCommands = combinedSessionObject.client_commands;
  const isRemote = hasPractitionerCommands || hasClientCommands;

  const renderOption = (key, val, className) => {
    switch (key) {
      case 'forms.notes':
        return (
          <SessionNotes
            sessionId={combinedSessionObject?.id}
            label={t(key)}
            val={val || t('undefined_variables.no_data')}
            className={className}
          />
        );
      default:
        return (
          <Box className={`row row-detail align-items-left ${className}`}>
            <Typography className='label' variant='h6'>
              {key}
            </Typography>
            <Typography className='value' variant='h6'>
              {val || t('undefined_variables.no_data')}
            </Typography>
          </Box>
        );
    }
  };

  const showRemoteValues = useMemo(() => {
    if (!isRemote) {
      return null;
    }
    const startDate = moment(combinedSessionObject.start_date).format(
      'DD/MM/YYYY [at] HH:mm',
    );
    const endDate = combinedSessionObject.end_date
      ? moment(combinedSessionObject.end_date).format('DD/MM/YYYY [at] HH:mm')
      : t('undefined_variables.no_date');
    const notes = (combinedSessionObject.notes || [])[0] || '';
    const sudScores = (combinedSessionObject.sud_array || []).join(',');
    const vocScores = (
      combinedSessionObject.validity_of_cognition_array || []
    ).join(',');
    const twilioRoomId =
      combinedSessionObject.twilio_room_id ||
      t('undefined_variables.no_twilio_room_id');
    return (
      <>
        {renderOption(t('forms.start_date'), startDate)}
        {renderOption(t('session-detail.end_date'), endDate)}
        {renderOption(t('session-detail.voc_scores'), vocScores)}
        {renderOption(t('session-detail.sud_scores'), sudScores)}
        {isAdmin
          ? renderOption(t('session-detail.twilio_room_id'), twilioRoomId)
          : null}
        {renderOption('forms.notes', notes, 'session-note')}
      </>
    );
  }, [combinedSessionObject, isAdmin, t]);

  const showVRvalues = useMemo(() => {
    if (isRemote) {
      return null;
    }
    const startDate = moment(combinedSessionObject.start_date).format(
      'DD/MM/YYYY [at] HH:mm',
    );
    const endDate = combinedSessionObject.end_date
      ? moment(combinedSessionObject.end_date).format('DD/MM/YYYY [at] HH:mm')
      : t('undefined_variables.no_date');
    const sudScores = (combinedSessionObject.sud_array || []).join(',');
    const vocScores = (
      combinedSessionObject.validity_of_cognition_array || []
    ).join(',');
    const bodyPartAffected = combinedSessionObject.body_part_affected;
    const compositeNc = combinedSessionObject.composite_nc;
    const emotionSelect = combinedSessionObject.emotion_select;
    const positiveCognition = combinedSessionObject.positive_cognition;
    const positiveLesson = combinedSessionObject.positive_lesson;
    return (
      <>
        {/* {renderOption('Body part affected', bodyPartAffected)} */}
        {renderOption(
          t('session-detail.vr.body_part_affected'),
          bodyPartAffected,
        )}

        {renderOption(t('session-detail.vr.composite_nc'), compositeNc)}
        {renderOption(t('session-detail.vr.emotion_select'), emotionSelect)}
        {renderOption(
          t('session-detail.vr.positive_cognition'),
          positiveCognition,
        )}
        {renderOption(t('session-detail.vr.positive_lesson'), positiveLesson)}
        {renderOption(t('forms.start_date'), startDate)}
        {renderOption(t('session-detail.end_date'), endDate)}
        {renderOption(t('session-detail.voc_scores'), vocScores)}
        {renderOption(t('session-detail.sud_scores'), sudScores)}
      </>
    );
  }, [combinedSessionObject]);

  return (
    <>
      {showRemoteValues}
      {showVRvalues}
    </>
  );
};
